import { Component, OnInit } from '@angular/core';

import { faLockAlt } from '@fortawesome/pro-solid-svg-icons';

import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'dx-app-auth-error',
  templateUrl: './app-auth-error.component.html',
  styleUrls: ['./app-auth-error.component.scss']
})
export class AppAuthErrorComponent implements OnInit {

  faLockAlt = faLockAlt;

  constructor(public authService: AuthService) { }

  ngOnInit() {
  }

  retryLogin() {
    this.authService.logout();
  }

}
